import React, { useState, useEffect } from 'react';
import { Box, Text, Flex, Image, Button } from 'rebass';
import Wrapper from './Wrapper';
import { getAssetUrlsAndAttributes, InlineEditing } from 'app/payment/GiftCertificateStyle';
import BabyBear_CheckingMailbox from './assets/BabyBear_CheckingMailbox.png'
import useSWR from 'swr';
import { get, patch } from 'utils/api';
import { toggleNavigationVisible } from 'ui/actions';
import useHistory from 'app/hooks/history';
import store from 'store';

const GiftCertificatePreview = ({ certificateId, setOrderQuantity, orderQuantity, createdCount, renderheader, member, setCreatedCount, isAllCreated, hideSkip, isDisabled, onStepUp, onStepDown, name_of_recipient, name_of_giver, gift_certificate_style_id, setGiftCertificateStyleId }) => {
    const { push } = useHistory();

    const { data } = useSWR(`/v3/commerce/gift_certificate_styles`);
    const certificatesData = getAssetUrlsAndAttributes(data);
    const [posterSectionWidth, setPosterSectionWidth] = useState(0);
    const [parentHeight, setParentHeight] = useState(null);
    const [zoom, setZoom] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const currentCollection = store.get('current_collection')

    useEffect(() => {
        const initializeOrderQuantity = async () => {
            const queryParams = new URLSearchParams(window.location.search);
            const orderParamQuantity = queryParams.get('orderQuantity');
            if ((orderParamQuantity === null || orderParamQuantity === 'null') && orderQuantity === 1) {
                try {
                    const shopifyOrderId = queryParams.get('shopifyOrderId');

                    if (shopifyOrderId) {
                        const { data: shopifyOrdersData } = await get(
                            `/v3/shopify_orders/${shopifyOrderId}`
                        );

                        const quantity = shopifyOrdersData?.initial?.data?.attributes?.['quantity'];

                        if (quantity) {
                            setOrderQuantity(quantity);
                        }
                    }
                } catch (error) {
                    setOrderQuantity(1); // ✅ Fallback to 1
                }
            }
        };

        initializeOrderQuantity();
    }, [])

    useEffect(() => {
        if (certificatesData.length > 0) {
            if (gift_certificate_style_id)
                setSelectedImage(certificatesData.find(certificate => certificate?.id === gift_certificate_style_id))
            // else {
            //     if (setGiftCertificateStyleId)
            //         setGiftCertificateStyleId(certificatesData[0]?.id)
            // }
        }
    }, [gift_certificate_style_id, certificatesData?.length])

    if (success)
        return <Wrapper
            hideSkip={hideSkip}
            isDisabled={isDisabled || isSubmitting}
            // onSubmit={onStepUp}
            onBack={() => setSuccess(false)}
            bg="aliceBlue"
            nextButtonText='Confirm certificate'
        >
            <Flex flexDirection="column" m="auto" my="4.7%" width={['100%', '100%', '50%']} minWidth={['max-width', 480]}>
                <Text px={2} mb="6.7%" color="codGrey"
                    fontFamily="Bitter"
                    fontSize={30}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                    textAlign="center">Your gift{orderQuantity > 1 ? 's' : ''} {orderQuantity > 1 ? 'are' : 'is'} ready to share!</Text>
                <Text
                    mb="30px"
                    color="#64748B"
                    fontFamily="Poppins"
                    fontSize="18px"
                    lineHeight="150%"
                    letterSpacing="-0.108px"
                    textAlign="center"
                >
                    We’ve emailed your gift{orderQuantity > 1 ? 's' : ''} certificate{orderQuantity > 1 ? 's' : ''}. Check spam if you don’t see it.
                </Text>
                {(currentCollection && currentCollection?.id && member?.['has-username-password-identifier']) && <Button
                    bg="brand"
                    m="auto"
                    my={4}
                    sx={{
                        borderRadius: '23px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: 'max-content'
                    }}
                    onClick={() => {
                        push(`/child-journals/${currentCollection?.id}`);
                    }}> To Dashboard</Button>}
                <Image width={['353px', '480px']} m="auto" src={BabyBear_CheckingMailbox} />
            </Flex>
        </Wrapper>

    return (
        <Wrapper
            hideSkip={hideSkip}
            isDisabled={isDisabled}
            onSubmit={async () => {
                setIsSubmitting(true)
                await patch(`/v3/commerce/gift_certificates/${certificateId}/confirm`)

                if ((createdCount + 1) >= orderQuantity)
                    setSuccess(true)
                else if (setCreatedCount)
                    onStepUp()
                // setSuccess(true)
                setIsSubmitting(false)
            }}
            onBack={onStepDown}
            bg="aliceBlue"
            nextButtonText={<>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.0081416 0.833333C0.0081416 0.3731 0.381233 0 0.841475 0H14.1667C14.6269 0 15 0.3731 15 0.833333V10.2702C15 11.1907 14.2538 11.9368 13.3333 11.9368H1.66667C0.746192 11.9368 0 11.1907 0 10.2702V1.10352C0 1.06383 0.00277493 1.0248 0.0081416 0.986592V0.833333ZM1.66667 2.68647V10.2702H13.3333V2.68675L9.26792 6.75217C8.29158 7.72851 6.70867 7.72851 5.73237 6.75217L1.66667 2.68647ZM2.97693 1.63971H12.0233L8.08942 5.57368C7.764 5.89909 7.23633 5.89909 6.91092 5.57368L2.97693 1.63971Z" fill="white" />
                </svg>&nbsp;
                Send certificate to my email
            </>}
            renderheader={renderheader}
        >
            <Box m="auto" my={["100px", "8.7%"]} mt="2.35% !important" width={['100%', '100%', '50%']} minWidth={['max-width', 480]}>
                <Text px={2} mb="6.7%" color="codGrey"
                    fontFamily="Bitter"
                    fontSize={30}
                    lineHeight="120%"
                    letterSpacing="-0.18px"
                    textAlign="center">Review your gift certificate</Text>

                <Flex
                    width="100%"
                    height={['unset', 'unset', 720]}
                    overflow="auto"
                    justifyContent="center"
                    alignItem="center"
                    sx={{
                        position: 'relative', borderRadius: '8px',
                        border: '1px solid rgba(0, 0, 0, 0.05)',
                        background: '#FAFAFA'
                    }}
                    ref={(el) => {
                        if (!el) return;
                        setPosterSectionWidth(el.getBoundingClientRect().width);
                        setParentHeight(el.getBoundingClientRect().height);
                    }}
                >
                    <InlineEditing
                        posterSectionWidth={posterSectionWidth}
                        parentHeight={parentHeight}
                        certificateDetails={selectedImage}
                        zoom={zoom}
                        setZoom={setZoom}
                        name_of_recipient={name_of_recipient}
                        name_of_giver={name_of_giver}
                    />
                </Flex>
            </Box>
        </Wrapper>
    )
};

export default GiftCertificatePreview;
